export enum ReactQueryKey {
  FETCH_ORDERS = 'fetchOrders',
  FETCH_ORDER = 'order',
  FETCH_STORAGE_UNIT_ORDERS = 'fetchStorageUnitOrders',
}
